// ===== Reusable Formspree initializer ======================================
function initFormspreeForm({
	formSelector,
	endpoint,
	fields,
	validate,
	asJSON = false,
	successWrapperClass = "successWrapper",
	successTitleClass = "successtitle",
	successDescClass = "successdesc",
	successTitle = "Thank you for submitting!",
	successDesc = "You will be updated soon...",
	submitBtnSelector = 'button[type="submit"]',
}) {
	const form = document.querySelector(formSelector);
	if (!form) return;

	const submitBtn = form.querySelector(submitBtnSelector);

	// Inline message area inside the form
	const msg = document.createElement("div");
	msg.setAttribute("aria-live", "polite");
	msg.style.marginTop = "12px";
	form.appendChild(msg);

	function getValues() {
		const out = {};
		for (const [key, id] of Object.entries(fields)) {
			const el = document.getElementById(id);
			out[key] = (el?.value ?? "").trim();
		}
		return out;
	}

	async function postToFormspree(payload) {
		const options = {
			method: "POST",
			headers: { Accept: "application/json" },
			body: asJSON ? JSON.stringify(payload) : payload,
		};
		if (asJSON) options.headers["Content-Type"] = "application/json";

		const res = await fetch(endpoint, options);
		const data = await res.json().catch(() => ({}));
		if (!res.ok) {
			const detail =
				data?.errors?.map((e) => e.message).join(", ") ||
				data?.message ||
				res.statusText;
			throw new Error(detail);
		}
		return data;
	}

	function showSuccessBelowForm() {
		// allow one success wrapper per page (or key by class if you want per-form)
		let wrapper = document.querySelector(`.${successWrapperClass}`);
		if (!wrapper) {
			wrapper = document.createElement("div");
			wrapper.className = successWrapperClass;
			wrapper.setAttribute("role", "status");
			wrapper.setAttribute("aria-live", "polite");

			const title = document.createElement("p");
			title.className = successTitleClass;
			title.textContent = successTitle;

			const desc = document.createElement("p");
			desc.className = successDescClass;
			desc.textContent = successDesc;

			wrapper.appendChild(title);
			wrapper.appendChild(desc);
			form.insertAdjacentElement("afterend", wrapper);
		} else {
			const title =
				wrapper.querySelector(`.${successTitleClass}`) ||
				wrapper.appendChild(document.createElement("p"));
			title.className = successTitleClass;
			title.textContent = successTitle;

			const desc =
				wrapper.querySelector(`.${successDescClass}`) ||
				wrapper.appendChild(document.createElement("p"));
			desc.className = successDescClass;
			desc.textContent = successDesc;
		}
	}

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		msg.textContent = "";
		msg.style.color = "";
		if (submitBtn) submitBtn.disabled = true;

		try {
			const values = getValues();
			const err = validate?.(values) || null;
			if (err) throw new Error(err);

			let body;
			if (asJSON) {
				body = values;
			} else {
				const fd = new FormData();
				Object.entries(values).forEach(([k, v]) => fd.append(k, v));
				body = fd;
			}

			await postToFormspree(body);
			form.reset();
			showSuccessBelowForm();
		} catch (error) {
			msg.style.color = "crimson";
			msg.textContent =
				"Submission failed: " + (error?.message || "Please try again.");
		} finally {
			if (submitBtn) submitBtn.disabled = false;
		}
	});
}

// ===== Initialize both forms once DOM is ready ==============================
document.addEventListener("DOMContentLoaded", () => {
	// Designer form
	initFormspreeForm({
		formSelector: 'form[action="https://formspree.io/f/meolzlnl"]',
		endpoint: "https://formspree.io/f/meolzlnl",
		fields: {
			name: "name",
			email: "email",
			companyName: "companyName",
			phoneCode: "phoneCode",
			phoneNumber: "phoneNumber",
			website: "website",
			instagramProfileLink: "instagramProfileLink",
			offertype: "offertype", // hidden multi-select
		},
		validate: (v) => {
			// if (!v.email) return "Email is required.";
			// if (!v.offertype) return "Please select a collection type.";
			// return null;
		},
		asJSON: false, // you're already using FormData here
		successWrapperClass: "successWrapper",
		successTitleClass: "successtitle",
		successDescClass: "successdesc",
		successTitle: "Thank you for submitting!",
		successDesc: "You will be updated soon...",
	});

	// Buyer form
	initFormspreeForm({
		formSelector: 'form[action="https://formspree.io/f/xovnlnrk"]',
		endpoint: "https://formspree.io/f/xovnlnrk",
		fields: {
			name: "buyer-name",
			email: "buyer-email",
			companyName: "buyer-companyName",
			phoneCode: "buyer-phoneCode",
			phoneNumber: "buyer-phoneNumber",
			website: "buyer-website",
			instagramProfileLink: "buyer-instagramProfileLink",
			collectionType: "buyer-collectionType", // hidden multi-select
		},
		validate: (v) => {
			// if (!v.email) return "Email is required.";
			// if (!v.collectionType) return "Please select a collection type.";
			return null;
		},
		asJSON: false, // FormData works well with files if you add later
		successWrapperClass: "successWrapper2",
		successTitleClass: "successtitle",
		successDescClass: "successdesc",
		successTitle: "Thank you for submitting!",
		successDesc: "You will be updated soon...",
	});
});

// === Reusable multi-select dropdown initializer ============================
function initCheckboxDropdown({
	hiddenId,
	displayId,
	menuId,
	arrowId = null,
	wrapperId = null,
	clearId = null,
	applyId = null,
	submitSource = "labels", // "labels" | "values"
	showCount = true, // show "N Selected" in the display input
	requiredMessage = "Please select at least one option.",
}) {
	const hidden = document.getElementById(hiddenId); // submitted field
	const display = document.getElementById(displayId); // visible input
	const menu = document.getElementById(menuId);
	const arrow = arrowId ? document.getElementById(arrowId) : null;
	const clear = clearId ? document.getElementById(clearId) : null;
	const apply = applyId ? document.getElementById(applyId) : null;

	// Wrapper: explicit (wrapperId) or nearest .input-wrapper from display
	const wrapper = wrapperId
		? document.getElementById(wrapperId)
		: display
		? display.closest(".input-wrapper")
		: null;

	if (!hidden || !display || !menu || !wrapper) return;

	const cbs = () => Array.from(menu.querySelectorAll(".checkbox-item"));

	function isOpen() {
		return !menu.classList.contains("hidden");
	}
	function openMenu() {
		if (isOpen()) return;
		menu.classList.remove("hidden");
		display.setAttribute("aria-expanded", "true");
		arrow?.classList.add("rotate-180");
	}
	function closeMenu() {
		if (!isOpen()) return;
		menu.classList.add("hidden");
		display.setAttribute("aria-expanded", "false");
		arrow?.classList.remove("rotate-180");
		display.blur();
	}

	function toggleMenu() {
		isOpen() ? closeMenu() : openMenu();
	}

	function getSelection() {
		const checked = cbs().filter((cb) => cb.checked);
		const labels = checked.map((cb) => cb.dataset.label || cb.value);
		const values = checked.map((cb) => cb.value);
		return { labels, values, count: checked.length };
	}

	function updateFields() {
		const { labels, values, count } = getSelection();

		// Visible input content
		if (showCount) {
			display.value = count > 0 ? `${count} Selected` : "";
		} else {
			display.value = labels.join(", ");
		}

		// Hidden submitted content
		const submit = submitSource === "values" ? values : labels;
		hidden.value = submit.join(", ");

		// Validity hint
		if (hidden.value) hidden.setCustomValidity("");
		if (!count) display.value = ""; // keep placeholder visible when empty
	}
	display.addEventListener("click", (e) => {
		e.preventDefault();
		toggleMenu();
	});

	if (arrow) {
		arrow.addEventListener("click", (e) => {
			e.preventDefault();
			toggleMenu();
		});
	}

	// Close when focus leaves the wrapper
	display.addEventListener("blur", () => {
		setTimeout(() => {
			if (!wrapper.contains(document.activeElement)) closeMenu();
		}, 0);
	});
	menu.addEventListener("focusout", () => {
		setTimeout(() => {
			if (!wrapper.contains(document.activeElement)) closeMenu();
		}, 0);
	});

	// Outside click closes
	document.addEventListener("mousedown", (e) => {
		if (!wrapper.contains(e.target)) closeMenu();
	});

	// Keyboard support on display
	display.addEventListener("keydown", (e) => {
		if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			openMenu();
			const first = cbs()[0];
			if (first) first.focus();
		}
		if (e.key === "Escape") closeMenu();
	});
	// Keyboard support inside menu
	menu.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeMenu();
			display.focus();
		}
	});

	// Live updates when selecting checkboxes
	menu.addEventListener("change", updateFields);

	// Footer actions (optional)
	if (clear) {
		clear.addEventListener("click", () => {
			cbs().forEach((cb) => (cb.checked = false));
			updateFields();
			display.focus();
		});
	}
	if (apply) {
		apply.addEventListener("click", () => {
			updateFields();
			closeMenu();
			display.focus();
		});
	}

	// Enforce required (if the hidden input has required attribute)
	const form = display.closest("form");
	if (form) {
		form.addEventListener("submit", (e) => {
			if (hidden.hasAttribute("required") && !hidden.value) {
				hidden.setCustomValidity(requiredMessage);
				hidden.reportValidity();
				e.preventDefault();
				openMenu();
				display.focus();
			}
		});
	}

	// Init
	updateFields();

	// Optional API if you ever need it
	return { openMenu, closeMenu, toggleMenu, updateFields, getSelection };
}

// === Initialize your two instances =========================================
document.addEventListener("DOMContentLoaded", () => {
	// 1) Buyer Collection Type
	initCheckboxDropdown({
		hiddenId: "buyer-collectionType",
		displayId: "buyer-collectionTypeDisplay",
		menuId: "buyer-collectionTypeMenu",
		arrowId: "buyer-collectionTypeArrow",
		// wrapper auto-detected via .input-wrapper
		submitSource: "labels",
		showCount: true,
	});

	// 2) Offer Type (designer)
	initCheckboxDropdown({
		hiddenId: "offertype",
		displayId: "offertypeDisplay",
		menuId: "offertypeMenu",
		arrowId: "offertypeArrow",
		wrapperId: "offertypeWrapper",
		clearId: "offertypeClear",
		applyId: "offertypeApply",
		submitSource: "labels",
		showCount: true,
	});
});

// Locale management
class LocaleManager {
	constructor() {
		this.currentLocale = "en";
		this.locales = {};
		this.init();
	}

	async init() {
		await this.loadLocales();
		this.setupLanguageSelector();
		this.updateContent();
	}

	async loadLocales() {
		try {
			const response = await fetch("locales/en.json");
			this.locales.en = await response.json();

			// Load other locales if they exist
			const locales = ["en"];
			for (const locale of locales) {
				try {
					const localeResponse = await fetch(`locales/${locale}.json`);
					this.locales[locale] = await localeResponse.json();
				} catch (error) {
					console.warn(`Locale ${locale} not found, using English fallback`);
					this.locales[locale] = this.locales.en;
				}
			}
		} catch (error) {
			console.error("Error loading locales:", error);
			// Fallback to hardcoded English
			this.locales.en = this.getFallbackLocales();
		}
	}

	getFallbackLocales() {
		return {
			title: "Gemina Web",
			brand: "Gemina",
			nav: {
				home: "Home",
				about: "About",
				services: "Services",
				contact: "Contact",
			},
			banner: {
				title: "Welcome to Gemina",
				subtitle: "Building the future with modern web technologies",
				cta: {
					primary: "Get Started",
					secondary: "Learn More",
				},
			},
			features: {
				speed: {
					title: "Lightning Fast",
					description:
						"Built with performance in mind for the best user experience.",
				},
				security: {
					title: "Secure by Default",
					description: "Enterprise-grade security built into every layer.",
				},
				quality: {
					title: "Premium Quality",
					description: "Crafted with attention to detail and best practices.",
				},
			},
			footer: {
				brand: "Gemina",
				description: "Amani",
				links: {
					title: "Quick Links",
					home: "Home",
					about: "About",
					services: "Services",
					contact: "Contact",
				},
				contact: {
					title: "Contact",
					email: "hello@gemina.com",
					phone: "+1 (555) 123-4567",
					address: "123 Web Street, Digital City",
				},
				copyright: "© 2024 Gemina. All rights reserved.",
			},
		};
	}

	setupLanguageSelector() {
		const selector = document.getElementById("languageSelector");
		if (selector) {
			selector.value = this.currentLocale;
			selector.addEventListener("change", (e) => {
				this.currentLocale = e.target.value;
				this.updateContent();
				this.updateDocumentLang();
			});
		}
	}

	updateDocumentLang() {
		document.documentElement.lang = this.currentLocale;
	}

	updateContent() {
		const elements = document.querySelectorAll("[data-locale]");
		elements.forEach((element) => {
			const key = element.getAttribute("data-locale");
			const value = this.getNestedValue(this.locales[this.currentLocale], key);
			if (value) {
				if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
					element.placeholder = value;
				} else {
					element.textContent = value;
				}
			}
		});
	}

	getNestedValue(obj, path) {
		return path.split(".").reduce((current, key) => {
			return current && current[key] !== undefined ? current[key] : null;
		}, obj);
	}
}

// Mobile menu functionality
class MobileMenu {
	constructor() {
		this.menuButton = document.querySelector(".mobile-menu-button");
		this.nav = document.querySelector("nav");
		this.init();
	}

	init() {
		if (this.menuButton) {
			this.menuButton.addEventListener("click", () => {
				this.toggleMenu();
			});
		}

		// Close menu when clicking outside
		document.addEventListener("click", (e) => {
			if (!this.nav.contains(e.target)) {
				this.closeMenu();
			}
		});
	}

	toggleMenu() {
		const isOpen = this.nav.classList.contains("mobile-menu-open");
		if (isOpen) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		this.nav.classList.add("mobile-menu-open");
		// Add mobile menu styles
		const navLinks = this.nav.querySelector(".ml-10");
		if (navLinks) {
			navLinks.classList.remove("hidden");
			navLinks.classList.add(
				"block",
				"absolute",
				"top-16",
				"left-0",
				"w-full",
				"bg-white",
				"shadow-lg",
				"border-t",
				"border-gray-200"
			);
		}
	}

	closeMenu() {
		this.nav.classList.remove("mobile-menu-open");
		const navLinks = this.nav.querySelector(".ml-10");
		if (navLinks) {
			navLinks.classList.add("hidden");
			navLinks.classList.remove(
				"block",
				"absolute",
				"top-16",
				"left-0",
				"w-full",
				"bg-white",
				"shadow-lg",
				"border-t",
				"border-gray-200"
			);
		}
	}
}

// Smooth scrolling for anchor links
class SmoothScroller {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener("click", (e) => {
				e.preventDefault();
				const target = document.querySelector(anchor.getAttribute("href"));
				if (target) {
					target.scrollIntoView({
						behavior: "smooth",
						block: "start",
					});
				}
			});
		});
	}
}

// Intersection Observer for animations
class AnimationObserver {
	constructor() {
		this.init();
	}

	init() {
		const observerOptions = {
			threshold: 0.1,
			rootMargin: "0px 0px -50px 0px",
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("animate-fade-in-up");
					observer.unobserve(entry.target);
				}
			});
		}, observerOptions);

		// Observe elements for animation
		document.querySelectorAll(".card, .bg-white").forEach((el) => {
			observer.observe(el);
		});
	}
}

// Form handling
class FormHandler {
	constructor() {
		this.init();
	}

	init() {
		const forms = document.querySelectorAll("form");
		forms.forEach((form) => {
			form.addEventListener("submit", (e) => {
				e.preventDefault();
				this.handleSubmit(form);
			});
		});
	}

	handleSubmit(form) {
		const formData = new FormData(form);
		const data = Object.fromEntries(formData);

		// Here you would typically send the data to your backend
		console.log("Form submitted:", data);

		// Show success message
		this.showMessage("Form submitted successfully!", "success");
	}

	showMessage(message, type = "info") {
		const messageDiv = document.createElement("div");
		messageDiv.className = `fixed top-4 right-4 p-4 rounded-lg shadow-lg ${
			type === "success" ? "bg-green-500 text-white" : "bg-blue-500 text-white"
		}`;
		messageDiv.textContent = message;

		document.body.appendChild(messageDiv);

		setTimeout(() => {
			messageDiv.remove();
		}, 3000);
	}
}

// Initialize all components when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
	new LocaleManager();
	new MobileMenu();
	new SmoothScroller();
	new AnimationObserver();
	new FormHandler();

	console.log("Gemina Web initialized successfully!");
});

// Add some interactive features
document.addEventListener("DOMContentLoaded", () => {
	// Add hover effects to feature cards
	const featureCards = document.querySelectorAll(".card");
	featureCards.forEach((card) => {
		card.addEventListener("mouseenter", () => {
			card.style.transform = "translateY(-5px)";
		});

		card.addEventListener("mouseleave", () => {
			card.style.transform = "translateY(0)";
		});
	});

	// Add click effects to buttons
	const buttons = document.querySelectorAll("button");
	buttons.forEach((button) => {
		button.addEventListener("click", () => {
			button.style.transform = "scale(0.95)";
			setTimeout(() => {
				button.style.transform = "scale(1)";
			}, 150);
		});
	});
});
